export default __webpack_public_path__ + "static/refuge-ac744aaa859687fad6a6ada7f6056e10.png";